import React, { useCallback } from "react"
import { LinkProvider } from "aldoo-ra/Button"
import useSiteLanguage from "./hooks/useSiteLanguage"

// Site links keep the /xx language prefix of non-English pages: every
// <Button href="/…"> resolves through here (Vike then intercepts the <a>).
// The admin is not a translated page (its route is /admin only): its links stay as they are.
/** A site path in a language: /vendor → /bg/vendor (English and the admin have no prefix). */
export const sitePath = (url, lang) =>
  lang && lang !== "en" && !/^\/[a-z]{2}(\/|$)/.test(url) && !/^\/admin(\/|$|\?)/.test(url) ? `/${lang}${url}` : url

export default function SiteLinks({ children }) {
  const lang = useSiteLanguage()
  const resolve = useCallback((url) => sitePath(url, lang), [lang])
  return <LinkProvider resolve={resolve}>{children}</LinkProvider>
}
